import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'


@Injectable({
  providedIn: 'root'
})
export class ApiErrorHandlingService {

  constructor() { }

  public handleError<T>(operation = 'operation', dispMessage = true, result?: T): any {
    return (error: any): Observable<T> => {
      console.error(error)
      if (dispMessage) {
        console.error('システムエラーが発生しました')
      }
      return of(result as T)
    }
  }
}
